import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

interface ISortedArray {
    [key: number]: any;
}
@Component({
    standalone: false,
    selector: 'zoning-code-changes-popup',
    templateUrl: './zoning-code-changes-popup.component.html',
    styleUrls: ['./zoning-code-changes-popup.component.scss']

})
export class ZoningCodeChangesPopupComponent {

    // public calibrationUsesLabels: ICalibrationUsesLabel[];
    // public overlayTypologyLabels: IOverlay[];
    // TODO :: Add correct typings
    public calibrationUsesLabels: any;
    public overlayTypologyLabels: any;

    constructor(
        public dialogRef: MatDialogRef<ZoningCodeChangesPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public zoningCodeChanges: any) {
        this.calibrationUsesLabels = this.getSortedArrayByField(this.modifiedUsesLabels, 'CalibrationUsesTypeId');
        this.overlayTypologyLabels = this.getSortedArrayByField(this.modifiedOverlaysTypology, 'BuildingCalibrationType');
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    private get modifiedUsesLabels() {
        return this.zoningCodeChanges && this.zoningCodeChanges.CalibrationUsesLabels;
    }

    private get modifiedOverlaysTypology() {
        return this.zoningCodeChanges && this.zoningCodeChanges.Overlays;
    }

    getSortedArrayByField(source: [], fieldForSort: string) {
        if (!source || !source.length) {
            return [];
        }

        source = (source as any).sort((a, b) => a['diffStatus'] - b['diffStatus']);
        const sortedArray: ISortedArray[] = [];
        source.forEach(value => {
            const data: any = _.get(value, fieldForSort);
            const field = data;
            const prevValue: any = sortedArray[field];
            sortedArray[field] = prevValue ? [...prevValue, value] : [value];
        });

        return sortedArray;
    }

}
